module.exports = __webpack_public_path__ + "static/media/fly0109.baeb7e59.webp";